import { MessageCircle } from "lucide-react";
import { type QuizConfig } from "~/types/quiz";

export const testAsertivnosti: QuizConfig = {
  id: "test-asertivnosti",
  illustration: {
    src: "/images/quizzes/test-asertivnosti.webp",
    alt: "Žena mirno postavlja granicu u razgovoru sa kolegom.",
  },
  lastModified: "2026-10-05",
  title: "Test asertivnosti: Kako izražavaš svoje potrebe?",
  shortTitle: "Test asertivnosti",
  description:
    "Besplatan test asertivnosti - otkrij da li jasno izražavaš svoje potrebe i kako postavljaš granice.",
  longDescription:
    "Ovaj test analizira tvoj stil komunikacije - da li si asertivan/na, pasivan/na ili agresivan/na u izražavanju potreba. Saznaćeš kako reaguješ na konflikt, koliko lako postavljaš granice i šta te sprečava da kažeš ono što misliš. Na kraju dobijaš konkretne tehnike za asertivnu komunikaciju i postavljanje zdravih granica.",
  icon: MessageCircle,
  duration: "3-5 min",
  category: "Odnosi i komunikacija",
  focusAreasWanted: [
    "boundaries",
    "communication",
    "self_development",
    "relationships",
  ],
  featured: false,
  questions: [
    {
      type: "radio",
      question: "Kada se ne slažeš sa nekim, kako obično reaguješ?",
      options: [
        "Jasno kažem svoje mišljenje, uz poštovanje",
        "Kažem, ali mi je neprijatno",
        "Zavisi od situacije i osobe",
        "Obično ćutim da ne bude problema",
        "Izbegavam konflikte po svaku cenu",
      ],
      scores: [4, 3, 2, 1, 0],
    },
    {
      type: "radio",
      question: "Kako reaguješ kada ti neko traži uslugu koju ne želiš da uradiš?",
      options: [
        "Kažem 'ne' bez previše objašnjavanja",
        "Kažem 'ne', ali se osećam loše",
        "Pokušam da nađem izgovor",
        "Često pristanem iako ne želim",
        "Skoro uvek pristanem",
      ],
      scores: [4, 3, 2, 1, 0],
    },
    {
      type: "radio",
      question: "Kada ti neko uvredi ili povredi osećanja, šta radiš?",
      options: [
        "Kažem toj osobi kako se osećam",
        "Kažem, ali tek kada se smirim",
        "Zavisi ko je u pitanju",
        "Obično prećutim",
        "Nikad ne reagujem na uvrede",
      ],
      scores: [4, 3, 2, 1, 0],
    },
    {
      type: "checkbox",
      checkboxScoring: "sum",
      question: "U kojim situacijama ti je najteže da kažeš šta misliš? (označi sve što važi)",
      options: [
        "Sa autoritetima (šef, profesor)",
        "Sa porodicom",
        "Sa partnerom/kom",
        "Sa prijateljima",
        "Sa nepoznatim ljudima",
        "Na poslu/faksu",
        "Nemam problem da kažem šta mislim",
      ],
      scores: [1, 1, 1, 1, 1, 1, 0],
    },
    {
      type: "radio",
      question: "Kako se osećaš kada treba da tražiš nešto što ti pripada (povraćaj novca, ispravku greške)?",
      options: [
        "Bez problema tražim ono što mi pripada",
        "Tražim, ali mi je malo neprijatno",
        "Zavisi od situacije",
        "Teško mi je, često odustanem",
        "Gotovo nikad ne tražim",
      ],
      scores: [4, 3, 2, 1, 0],
    },
    {
      type: "radio",
      question: "Kada neko prekorači tvoje granice, kako reaguješ?",
      options: [
        "Odmah postavim jasnu granicu",
        "Reagujem, ali mi treba vremena",
        "Ponekad reagujem, ponekad ne",
        "Retko reagujem, trpim",
        "Dozvolim drugima da prelaze granice",
      ],
      scores: [4, 3, 2, 1, 0],
    },
    {
      type: "textarea",
      question:
        "Opiši situaciju u kojoj ti je bilo teško da kažeš ono što stvarno misliš ili osećaš.",
    },
    {
      type: "radio",
      question: "Koliko često izraziš svoje potrebe u vezama (prijateljskim, porodičnim, romantičnim)?",
      options: [
        "Uvek kažem šta mi treba",
        "Uglavnom kažem",
        "Ponekad kažem, ponekad ne",
        "Retko kažem šta mi treba",
        "Gotovo nikad ne izražavam potrebe",
      ],
      scores: [4, 3, 2, 1, 0],
    },
    {
      type: "radio",
      question: "Kako se osećaš posle razgovora u kojem si rekao/la nešto nepopularno?",
      options: [
        "Zadovoljno, jer sam bio/la iskren/a",
        "Uglavnom dobro, možda malo nelagodno",
        "Mešovito - i olakšanje i nelagoda",
        "Loše, preispitujem sebe",
        "Jako loše, dugo razmišljam o tome",
      ],
      scores: [4, 3, 2, 1, 0],
    },
    {
      type: "checkbox",
      checkboxScoring: "sum",
      question: "Šta ti pomaže da budeš asertivniji/a? (označi sve što važi)",
      options: [
        "Priprema unapred šta ću reći",
        "Podrška bliskih ljudi",
        "Vežbanje u manje stresnim situacijama",
        "Rad na samopouzdanju",
        "Razumevanje da imam pravo na svoje mišljenje",
        "Ništa od navedenog",
      ],
      scores: [1, 1, 1, 1, 1, 0],
    },
  ],
  copy: {
    title: "Tvoj stil komunikacije",
    subtitle: "Analiza tvoje asertivnosti",
    scoreLabel: "Rezultat:",
    adviceTitle: "Kako da razviješ asertivnost",
    resourcesTitle: "Korisni resursi",
    whatNextTitle: "Šta dalje?",
    shareButtonText: "Podeli rezultat",
  },
};
